import ApiService from './apiService';

// Fallback data in case API fails
const fallbackDevotions = [
  {
    id: 1,
    title: "Divine Response To Disrespect",
    text: "From a young age, I was taught the importance of showing respect to the elderly. It wasn't just about good manners—it was a way of life. Whether it was a neighbor, a stranger on the street, or a family member, anyone older than me deserved my respect. This principle was deeply ingrained in my character, shaping how I interacted with the world around me.",
    date: "2024-01-15"
  },
  {
    id: 2,
    title: "Walking in Faith",
    text: "Faith is not just a belief system; it's a way of life that requires daily practice and commitment. When we choose to walk in faith, we are choosing to trust in something greater than ourselves, even when the path ahead seems uncertain.",
    date: "2024-01-14"
  },
  {
    id: 3,
    title: "The Power of Prayer",
    text: "Prayer is our direct line of communication with the divine. It's not just about asking for things, but about building a relationship with God. Through prayer, we find strength, guidance, and peace in the midst of life's challenges.",
    date: "2024-01-13"
  }
];

// Get today's devotion
export const getTodaysDevotionData = async () => {
  try {
    console.log('🔄 Fetching today\'s devotion from API...');
    const result = await ApiService.getTodaysDevotion();
    
    if (result && result.today) {
      console.log('✅ Today\'s devotion loaded from API:', result.today.title);
      return result.today;
    } else {
      console.log('⚠️ No today\'s devotion from API, using fallback');
      return fallbackDevotions[0];
    }
  } catch (error) {
    console.error('❌ Error fetching today\'s devotion:', error);
    console.log('🔄 Using fallback devotion data');
    return fallbackDevotions[0];
  }
};

// Get previous devotions (before today)
export const getPreviousDevotionsData = async () => {
  try {
    console.log('🔄 Fetching previous devotions from API...');
    const devotions = await ApiService.getPreviousDevotions();
    
    if (devotions && devotions.length > 0) {
      console.log('✅ Previous devotions loaded from API:', devotions.length);
      return devotions;
    } else {
      console.log('⚠️ No previous devotions from API, using fallback');
      return fallbackDevotions;
    }
  } catch (error) {
    console.error('❌ Error fetching previous devotions:', error);
    console.log('🔄 Using fallback devotion data');
    return fallbackDevotions;
  }
};

// Get devotion by date
export const getDevotionByDateData = async (date) => {
  try {
    console.log('🔄 Fetching devotion for date:', date);
    const devotion = await ApiService.getDevotionByDate(date);
    
    if (devotion) {
      console.log('✅ Devotion loaded for date:', date, devotion.title);
      return devotion;
    } else {
      console.log('⚠️ No devotion found for date:', date);
      // Return a fallback devotion
      return fallbackDevotions.find(d => d.date === date) || fallbackDevotions[0];
    }
  } catch (error) {
    console.error('❌ Error fetching devotion by date:', error);
    console.log('🔄 Using fallback devotion data');
    return fallbackDevotions.find(d => d.date === date) || fallbackDevotions[0];
  }
};

// Get recent devotions (for future use)
export const getRecentDevotionsData = async () => {
  try {
    console.log('🔄 Fetching recent devotions from API...');
    const devotions = await ApiService.getRecentDevotions();
    
    if (devotions && devotions.length > 0) {
      console.log('✅ Recent devotions loaded from API:', devotions.length);
      return devotions;
    } else {
      console.log('⚠️ No recent devotions from API, using fallback');
      return fallbackDevotions.slice(0, 5);
    }
  } catch (error) {
    console.error('❌ Error fetching recent devotions:', error);
    console.log('🔄 Using fallback devotion data');
    return fallbackDevotions.slice(0, 5);
  }
}; 

// Generate calendar devotions for the calendar view
export const generateCalendarDevotions = async () => {
  try {
    console.log('🔄 Generating calendar devotions...');
    
    // Get all available devotions
    const [todaysData, previousData, recentData] = await Promise.all([
      getTodaysDevotionData(),
      getPreviousDevotionsData(),
      getRecentDevotionsData()
    ]);
    
    // Combine all devotions and remove duplicates
    const allDevotions = [];
    const seenIds = new Set();
    
    // Add today's devotion
    if (todaysData && !seenIds.has(todaysData.id)) {
      allDevotions.push(todaysData);
      seenIds.add(todaysData.id);
    }
    
    // Add previous devotions
    if (previousData && Array.isArray(previousData)) {
      previousData.forEach(devotion => {
        if (devotion && !seenIds.has(devotion.id)) {
          allDevotions.push(devotion);
          seenIds.add(devotion.id);
        }
      });
    }
    
    // Add recent devotions
    if (recentData && Array.isArray(recentData)) {
      recentData.forEach(devotion => {
        if (devotion && !seenIds.has(devotion.id)) {
          allDevotions.push(devotion);
          seenIds.add(devotion.id);
        }
      });
    }
    
    // If no devotions from API, use fallback
    if (allDevotions.length === 0) {
      console.log('⚠️ No devotions available, using fallback data');
      return fallbackDevotions;
    }
    
    console.log('✅ Calendar devotions generated:', allDevotions.length);
    return allDevotions;
    
  } catch (error) {
    console.error('❌ Error generating calendar devotions:', error);
    console.log('🔄 Using fallback devotion data');
    return fallbackDevotions;
  }
};